import { Pipe, PipeTransform } from "@angular/core";
import { FormGroup } from "@angular/forms";

@Pipe({
  name: "arrayFilter"
})
export class FormArrayFilterPipe<T> implements PipeTransform {

  public transform(areaList: T[], name: string, key: string): T[] | undefined {
    if (!name || name.length == 0 || !key || key.length == 0) {
      return areaList;
    } else if (areaList) {
      return areaList.filter(
        (listing: FormGroup | T) => {
          if ((listing as FormGroup).controls) {
            return this.handleValue((listing as FormGroup).get(key)?.value.toString(), name);
          } else {
            return this.handleValue((listing as any)[key].toString(), name);
          }
        }    
      );
    }
  }

  private handleValue(value: string, name: string): boolean {
    return value.toLocaleLowerCase().indexOf(name) > -1;
  }
}
